export default "__VITE_ASSET__DGM2751a__"